var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerkehrsrechtGeschwindigkeitsverstossV2Dark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 921,
    height: 561,
    viewBox: "0 0 921 561",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_170_2841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.199 392.398H84.1992V398.398H247.199V392.398Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.199 392.398H453.199V398.398H616.199V392.398Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.199 392.398H704.199V398.398H867.199V392.398Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.202 301.5C866.702 302.3 865.302 303.2 864.102 304.4C862.802 303.3 861.402 302.3 859.902 301.5C858.402 302.3 857.002 303.2 855.802 304.4C854.502 303.3 853.102 302.3 851.602 301.5C851.602 301.5 845.102 304.7 845.102 308.6C845.102 308.7 845.102 308.8 845.102 308.9C845.302 311.5 852.002 312.1 855.702 310.9C858.402 311.7 861.302 311.7 864.102 310.9C867.802 312.1 874.602 311.4 874.802 308.8C874.802 308.7 874.802 308.6 874.802 308.5C874.702 304.7 868.202 301.5 868.202 301.5Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99922 167.099L1.19922 162.499L33.4992 133.699H115.399V158.999L62.2992 194.799L6.99922 167.099Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.298 149.799V134.199H119.498V138.099L115.398 133.699L88.8984 162.499L78.4984 169.399L62.3984 286.999L86.6984 311.299H143.098V163.599L130.298 149.799Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8992 162.5H1.19922V311.3H88.8992V162.5Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2992 275H35.1992V311.3H51.2992V275Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9 285.302V279.602H11V285.302H17.4H17.9Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4 290H11V295.7H17.9V290H17.4Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4 279.602H22.5V285.402H29.4V279.602Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4 290H22.5V295.8H29.4V290Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2008 285.302V279.602H58.3008V285.302H64.6008H65.2008Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6008 290H58.3008V295.7H65.2008V290H64.6008Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7008 279.602H69.8008V285.402H76.7008V279.602Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7008 290H69.8008V295.8H76.7008V290Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.699 169.999V164.199H106.699V169.999H113.099H113.699Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.099 174.602H106.699V180.402H113.699V174.602H113.099Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.201 164.199H118.301V169.999H125.201V164.199Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.201 174.602H118.301V180.402H125.201V174.602Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.699 202.3V196.5H106.699V202.3H113.099H113.699Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.099 206.898H106.699V212.698H113.699V206.898H113.099Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.201 196.5H118.301V202.3H125.201V196.5Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.201 206.898H118.301V212.698H125.201V206.898Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.699 234.601V228.801H106.699V234.601H113.099H113.699Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.099 239.199H106.699V244.999H113.699V239.199H113.099Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.201 228.801H118.301V234.601H125.201V228.801Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.201 239.199H118.301V244.999H125.201V239.199Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.699 266.902V261.102H106.699V266.902H113.099H113.699Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.099 271.5H106.699V277.3H113.699V271.5H113.099Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.201 261.102H118.301V266.902H125.201V261.102Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.201 271.5H118.301V277.3H125.201V271.5Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9 170H11V183.8H77.9V170Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9 197.699H11V211.499H77.9V197.699Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9 225.398H11V239.198H77.9V225.398Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9 253H11V266.8H77.9V253Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.202 302.398C136.702 303.198 135.302 304.098 134.102 305.298C132.802 304.198 131.402 303.198 129.902 302.398C128.402 303.198 127.002 304.098 125.802 305.298C124.502 304.198 123.102 303.198 121.602 302.398C121.602 302.398 115.102 305.598 115.102 309.498C115.102 309.598 115.102 309.698 115.102 309.798C115.302 312.398 122.002 312.998 125.702 311.798C128.402 312.598 131.302 312.598 134.102 311.798C137.802 312.998 144.602 312.298 144.802 309.698C144.802 309.598 144.802 309.498 144.802 309.398C144.702 305.498 138.202 302.398 138.202 302.398Z",
    fill: "#137F7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.198 167.099L102.398 162.499L134.698 133.699H216.598V158.999L163.498 194.799L108.198 167.099Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.502 149.799V134.199H220.702V138.099L216.602 133.699L190.102 162.499L179.702 169.399L163.602 286.999L187.902 311.299H244.302V163.599L231.502 149.799Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.098 162.5H102.398V311.3H190.098V162.5Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.498 275H136.398V311.3H152.498V275Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.099 285.302V279.602H112.199V285.302H118.599H119.099Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.599 290H112.199V295.7H119.099V290H118.599Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.599 279.602H123.699V285.402H130.599V279.602Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.599 290H123.699V295.8H130.599V290Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.4 285.302V279.602H159.5V285.302H165.9H166.4Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.9 290H159.5V295.7H166.4V290H165.9Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.9 279.602H171V285.402H177.9V279.602Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.9 290H171V295.8H177.9V290Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.9 169.999V164.199H208V169.999H214.3H214.9Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.3 174.602H208V180.402H214.9V174.602H214.3Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.4 164.199H219.5V169.999H226.4V164.199Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.4 174.602H219.5V180.402H226.4V174.602Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.9 202.3V196.5H208V202.3H214.3H214.9Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.3 206.898H208V212.698H214.9V206.898H214.3Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.4 196.5H219.5V202.3H226.4V196.5Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.4 206.898H219.5V212.698H226.4V206.898Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.9 234.601V228.801H208V234.601H214.3H214.9Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.3 239.199H208V244.999H214.9V239.199H214.3Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.4 228.801H219.5V234.601H226.4V228.801Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.4 239.199H219.5V244.999H226.4V239.199Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.9 266.902V261.102H208V266.902H214.3H214.9Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.3 271.5H208V277.3H214.9V271.5H214.3Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.4 261.102H219.5V266.902H226.4V261.102Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.4 271.5H219.5V277.3H226.4V271.5Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.099 170H112.199V183.8H179.099V170Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.099 197.699H112.199V211.499H179.099V197.699Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.099 225.398H112.199V239.198H179.099V225.398Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.099 253H112.199V266.8H179.099V253Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.3 200.398H302.5V310.698H305.3V200.398Z",
    fill: "#868A91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.601 232.598C332.601 233.798 332.601 234.998 332.601 236.198C331.601 279.598 279.501 279.898 278.101 236.498C278.101 235.298 278.001 234.098 278.001 232.898C277.801 184.398 304.901 144.898 304.901 144.898C304.901 144.898 332.301 183.998 332.601 232.598Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.6 302.102C294.1 302.902 292.7 303.802 291.5 305.002C290.2 303.902 288.8 302.902 287.3 302.102C285.8 302.902 284.4 303.802 283.2 305.002C281.9 303.902 280.5 302.902 279 302.102C279 302.102 272.5 305.302 272.5 309.202C272.5 309.302 272.5 309.402 272.5 309.502C272.7 312.102 279.4 312.702 283.1 311.502C285.8 312.302 288.7 312.302 291.5 311.502C295.2 312.702 302 312.002 302.2 309.402C302.2 309.302 302.2 309.202 302.2 309.102C302.1 305.202 295.6 302.102 295.6 302.102Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.701 264L370.301 258.2L402.601 205.5H485.601V213.5L455.601 270.9L421.001 277.8L373.701 264Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.902 246.799V203.699H489.002V209.299L485.602 205.499L457.902 258.199L453.302 262.799L447.602 285.899L457.902 311.299H511.002V259.399L499.902 246.799Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.001 258.199H370.301V311.299H458.001V258.199Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.898 275H427.398V291.1H445.898V275Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.799 274.398H403.699V311.298H419.799V274.398Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.298 280.098V274.398H378.398V280.098H384.698H385.298Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.698 284.801H378.398V290.501H385.298V284.801H384.698Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.798 274.398H389.898V280.198H396.798V274.398Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.798 284.801H389.898V290.601H396.798V284.801Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.701 281.601V275.801H475.801V281.601H482.201H482.701Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.201 286.199H475.801V291.899H482.701V286.199H482.201Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.298 275.801H487.398V281.601H494.298V275.801Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.298 286.199H487.398V291.999H494.298V286.199Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.002 227.099L409.102 225.599L417.602 211.699H439.502V213.899L431.602 228.999L422.502 230.799L410.002 227.099Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.5 211.699L432.2 225.599L431 226.799L429.5 232.899L432.2 239.599H446.2V225.899L439.5 211.699Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.202 225.602H409.102V239.602H432.202V225.602Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.902 231.598V228.898H415.602V231.598H418.602H418.902Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.602 233.898H415.602V236.598H418.902V233.898H418.602Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.402 228.898H421.102V231.698H424.402V228.898Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.402 233.801H421.102V236.601H424.402V233.801Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.301 264L474.801 258.2L507.101 205.5H590.201V213.5L560.201 270.9L525.601 277.8L478.301 264Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.502 246.799V203.699H593.602V209.299L590.202 205.499L562.502 258.199L557.902 262.799L552.102 285.899L562.502 311.299H615.602V259.399L604.502 246.799Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.501 258.199H474.801V311.299H562.501V258.199Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.398 275H531.898V291.1H550.398V275Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.401 274.398H508.301V311.298H524.401V274.398Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.798 280.098V274.398H482.898V280.098H489.198H489.798Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.198 284.801H482.898V290.501H489.798V284.801H489.198Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.298 274.398H494.398V280.198H501.298V274.398Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.298 284.801H494.398V290.601H501.298V284.801Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.298 280.7V275H580.398V280.7H586.698H587.298Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.698 285.301H580.398V291.101H587.298V285.301H586.698Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.798 275H591.898V280.8H598.798V275Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.798 285.301H591.898V291.101H598.798V285.301Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.5 264L576 258.2L608.3 205.5H691.4V213.5L661.4 270.9L626.8 277.8L579.5 264Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.701 246.799V203.699H694.801V209.299L691.401 205.499L663.701 258.199L659.101 262.799L653.301 285.899L663.701 311.299H716.801V259.399L705.701 246.799Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.7 258.199H576V311.299H663.7V258.199Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.602 275H633.102V291.1H651.602V275Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.6 274.398H609.5V311.298H625.6V274.398Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.002 280.098V274.398H584.102V280.098H590.502H591.002Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.502 284.801H584.102V290.501H591.002V284.801H590.502Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.502 274.398H595.602V280.198H602.502V274.398Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.502 284.801H595.602V290.601H602.502V284.801Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.502 280.7V275H681.602V280.7H687.902H688.502Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.902 285.301H681.602V291.101H688.502V285.301H687.902Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.002 275H693.102V280.8H700.002V275Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.002 285.301H693.102V291.101H700.002V285.301Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.099 228.002L511.199 226.502L519.699 212.602H541.499V214.702L533.599 229.802L524.499 231.602L512.099 228.002Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.5 212.602L534.2 226.502L533 227.702L531.5 233.802L534.2 240.402H548.2V226.802L541.5 212.602Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.299 226.5H511.199V240.5H534.299V226.5Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.902 232.499V229.699H517.602V232.499H520.702H520.902Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.702 234.699H517.602V237.399H520.902V234.699H520.702Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.402 229.699H523.102V232.499H526.402V229.699Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.402 234.699H523.102V237.499H526.402V234.699Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.099 227.099L613.199 225.599L621.699 211.699H643.599V213.899L635.699 228.999L626.599 230.799L614.099 227.099Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.6 211.699L636.3 225.599L635.1 226.799L633.5 232.899L636.3 239.599H650.2V225.899L643.6 211.699Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.299 225.602H613.199V239.602H636.299V225.602Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.999 231.598V228.898H619.699V231.598H622.699H622.999Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.699 233.898H619.699V236.598H622.999V233.898H622.699Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.499 228.898H625.199V231.698H628.499V228.898Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.499 233.801H625.199V236.601H628.499V233.801Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.002 264L680.602 258.2L712.902 205.5H795.902V213.5L765.902 270.9L731.302 277.8L684.002 264Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.198 212.899V203.699H799.398V209.299L795.898 205.499L768.198 258.199L763.598 262.799L757.898 285.899L768.198 311.299H821.298V259.399L810.198 212.899Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.302 258.199H680.602V311.299H768.302V258.199Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.199 275H737.699V291.1H756.199V275Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.1 274.398H714V311.298H730.1V274.398Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.599 280.098V274.398H688.699V280.098H694.999H695.599Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.999 284.801H688.699V290.501H695.599V284.801H694.999Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.099 274.398H700.199V280.198H707.099V274.398Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.099 284.801H700.199V290.601H707.099V284.801Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.002 280.7V275H786.102V280.7H792.502H793.002Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.502 285.301H786.102V291.101H793.002V285.301H792.502Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.599 275H797.699V280.8H804.599V275Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.599 285.301H797.699V291.101H804.599V285.301Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.199 228.002L715.199 226.502L723.699 212.602H745.599V214.702L737.699 229.802L728.599 231.602L716.199 228.002Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.602 212.602L738.302 226.502L737.102 227.702L735.602 233.802L738.302 240.402H752.302V226.802L745.602 212.602Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.299 226.5H715.199V240.5H738.299V226.5Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.999 232.499V229.699H721.699V232.499H724.699H724.999Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.699 234.699H721.699V237.399H724.999V234.699H724.699Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.499 229.699H727.199V232.499H730.499V229.699Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.499 234.699H727.199V237.499H730.499V234.699Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.401 310.699H0.800781V312.399H920.401V310.699Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.6 467.102H0V468.802H919.6V467.102Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.3 200.398H857.5V310.698H860.3V200.398Z",
    fill: "#868A91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.5 232.501C887.5 233.701 887.5 234.901 887.5 236.101C886.5 279.501 834.5 279.801 833 236.401C833 235.201 832.9 234.001 832.9 232.801C832.7 184.301 859.8 144.801 859.8 144.801C859.8 144.801 887.3 184.001 887.5 232.501Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.502 418.699H278.102V423.399H307.502V418.699Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.299 419.8L514.199 421.2L283.399 421.3L281.299 416.5C277.699 408.2 276.399 399.1 277.699 390.1C278.699 383.4 281.199 376.8 286.799 373.9L296.999 305.7L424.699 305.5L474.099 345.3C474.099 345.3 497.399 344.9 510.099 360.6C514.099 365.6 516.999 372.2 517.799 381L518.299 389.2L520.299 419.8Z",
    fill: "#137F7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.602 447.102C485.342 447.102 498.102 434.342 498.102 418.602C498.102 402.861 485.342 390.102 469.602 390.102C453.861 390.102 441.102 402.861 441.102 418.602C441.102 434.342 453.861 447.102 469.602 447.102Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.602 433.602C477.886 433.602 484.602 426.886 484.602 418.602C484.602 410.317 477.886 403.602 469.602 403.602C461.317 403.602 454.602 410.317 454.602 418.602C454.602 426.886 461.317 433.602 469.602 433.602Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329 447.199C344.74 447.199 357.5 434.439 357.5 418.699C357.5 402.959 344.74 390.199 329 390.199C313.26 390.199 300.5 402.959 300.5 418.699C300.5 434.439 313.26 447.199 329 447.199Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329 433.699C337.284 433.699 344 426.983 344 418.699C344 410.415 337.284 403.699 329 403.699C320.716 403.699 314 410.415 314 418.699C314 426.983 320.716 433.699 329 433.699Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.6 340.602L385.7 340.702H377.2H363V339.602V327.102V313.102H372.5H380.9H395.8H404.2H421.4L454.6 340.602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.798 340.702H315.398V333.602V321.102V313.102H320.698H329.098H351.798V340.702Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.7 361.199H363V370.099H367.7V361.199Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.798 348.602H435.898V353.302H444.798V348.602Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.199 331.102H439.699C445.099 331.102 449.499 335.502 449.499 340.902C449.499 346.302 445.099 350.702 439.699 350.702H439.199V331.102Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.402 389.202C510.102 390.102 502.702 384.102 501.802 375.802C501.102 369.502 504.502 363.402 510.202 360.602C514.202 365.602 517.102 372.202 517.902 381.002L518.402 389.202Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.9 313.102L363 339.602V327.102L372.5 313.102H380.9Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.098 313.102L315.398 333.602V321.102L320.698 313.102H329.098Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.199 313.102L385.699 340.702H377.199L395.799 313.102H404.199Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.998 536.301C138.998 536.301 134.398 546.401 130.598 549.201C126.798 546.401 122.098 536.301 122.098 536.301C122.098 536.301 117.498 546.401 113.698 549.201C109.898 546.401 105.198 536.301 105.198 536.301C105.198 536.301 91.9982 549.701 92.0982 556.101C92.0982 556.301 92.0982 556.401 92.0982 556.601C92.4982 560.801 106.098 561.801 113.598 559.901C119.198 561.201 124.898 561.201 130.498 559.901C137.898 561.901 151.798 560.801 152.198 556.501C152.198 556.301 152.198 556.201 152.198 556.001C152.198 549.601 138.998 536.301 138.998 536.301Z",
    fill: "#137F7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.298 536.301C415.298 536.301 410.698 546.401 406.898 549.201C403.098 546.401 398.398 536.301 398.398 536.301C398.398 536.301 393.798 546.401 389.998 549.201C386.198 546.401 381.498 536.301 381.498 536.301C381.498 536.301 368.398 549.701 368.398 556.101C368.398 556.301 368.398 556.401 368.398 556.601C368.798 560.801 382.398 561.801 389.898 559.901C395.498 561.201 401.198 561.201 406.798 559.901C414.198 561.901 428.098 560.801 428.498 556.501C428.498 556.301 428.498 556.201 428.498 556.001C428.498 549.601 415.298 536.301 415.298 536.301Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.701 536.301C689.701 536.301 685.101 546.401 681.301 549.201C677.501 546.401 672.801 536.301 672.801 536.301C672.801 536.301 668.201 546.401 664.401 549.201C660.601 546.401 655.901 536.301 655.901 536.301C655.901 536.301 642.801 549.701 642.801 556.101C642.801 556.301 642.801 556.401 642.801 556.601C643.201 560.801 656.801 561.801 664.301 559.901C669.901 561.201 675.601 561.201 681.201 559.901C688.601 561.901 702.501 560.801 702.901 556.501C702.901 556.301 702.901 556.201 702.901 556.001C702.901 549.601 689.701 536.301 689.701 536.301Z",
    fill: "#137F7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.599 47.2992L155.499 47.3992C152.799 48.8992 149.599 48.8992 146.999 47.3992C146.899 47.3992 146.799 47.2992 146.799 47.2992C144.099 45.8992 140.899 45.8992 138.299 47.2992L138.199 47.3992C135.499 48.8992 132.299 48.8992 129.699 47.3992C129.599 47.3992 129.499 47.2992 129.499 47.2992C126.899 45.8992 123.699 45.8992 120.999 47.2992C116.999 49.3992 111.699 53.0992 111.699 57.1992C111.699 57.3992 111.699 57.4992 111.699 57.6992C111.999 61.9992 125.999 63.0992 133.699 60.9992C139.399 62.2992 145.399 62.2992 151.099 60.9992C158.799 63.0992 172.999 61.8992 173.499 57.4992C173.499 57.2992 173.499 57.1992 173.499 56.9992C173.499 52.8992 168.099 49.1992 164.099 47.0992C161.399 45.7992 158.199 45.8992 155.599 47.2992Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.701 92.6019L415.601 92.7019C412.901 94.2019 409.701 94.2019 407.101 92.7019C407.001 92.7019 406.901 92.6019 406.901 92.6019C404.201 91.2019 401.001 91.2019 398.401 92.6019L398.301 92.7019C395.601 94.2019 392.401 94.2019 389.801 92.7019C389.701 92.7019 389.601 92.6019 389.601 92.6019C387.001 91.2019 383.801 91.2019 381.101 92.6019C377.101 94.7019 371.801 98.4019 371.801 102.502C371.801 102.702 371.801 102.802 371.801 103.002C372.301 107.302 386.301 108.402 393.901 106.402C399.601 107.702 405.601 107.702 411.301 106.402C419.001 108.502 433.201 107.302 433.701 102.902C433.701 102.702 433.701 102.602 433.701 102.402C433.701 98.3019 428.301 94.6019 424.301 92.5019C421.501 91.2019 418.401 91.2019 415.701 92.6019Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.502 49.3019L595.402 49.4019C592.702 50.9019 589.502 50.9019 586.902 49.4019C586.802 49.4019 586.702 49.3019 586.702 49.3019C584.002 47.9019 580.802 47.9019 578.202 49.3019L578.102 49.4019C575.402 50.9019 572.202 50.9019 569.602 49.4019C569.502 49.4019 569.402 49.3019 569.402 49.3019C566.802 47.9019 563.602 47.9019 560.902 49.3019C556.902 51.4019 551.602 55.1019 551.602 59.2019C551.602 59.4019 551.602 59.5019 551.602 59.7019C552.102 64.0019 566.102 65.1019 573.702 63.1019C579.402 64.4019 585.402 64.4019 591.102 63.1019C598.802 65.2019 613.002 64.0019 613.502 59.6019C613.502 59.4019 613.502 59.3019 613.502 59.1019C613.502 55.0019 608.102 51.3019 604.102 49.2019C601.302 47.8019 598.102 47.8019 595.502 49.3019Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.6 559.102H0V560.802H919.6V559.102Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.4 330.5H171V336.5H285.4V330.5Z",
    fill: "#137F7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.398 344.5H203.898V350.5H281.398V344.5Z",
    fill: "#137F7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.901 359.5H224.801V365.5H274.901V359.5Z",
    fill: "#137F7B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_170_2841"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 920.4,
    height: 560.8,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerkehrsrechtGeschwindigkeitsverstossV2Dark);
export default __webpack_public_path__ + "static/media/Verkehrsrecht_Geschwindigkeitsverstoss_v2_dark.249c124b5bae5433baa700b7169e70d4.svg";
export { ForwardRef as ReactComponent };